import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Spin } from "antd";
import authService from "services/authService";
import { getUser, isAdmin, saveUser } from "utilities/authSession";
import RouteEnum from "constants/RouteEnum";

export const RequireAuth = () => {
  const location = useLocation();
  const [state, setState] = useState(() => (getUser() ? "ready" : "loading"));

  useEffect(() => {
    let cancelled = false;
    authService
      .session()
      .then(({ user }) => {
        if (cancelled) return;
        saveUser(user);
        setState("ready");
      })
      .catch(() => {
        if (cancelled) return;
        setState("unauthorized");
      });
    return () => {
      cancelled = true;
    };
  }, [location.pathname]);

  if (state === "unauthorized") {
    return <Navigate to={RouteEnum.Login} state={{ from: location }} replace />;
  }
  if (state === "loading" && !getUser()) {
    return <Spin fullscreen />;
  }
  return <Outlet />;
};

export const RequireAdmin = () => {
  const location = useLocation();
  const [state, setState] = useState(() =>
    isAdmin() ? "ready" : getUser() ? "forbidden" : "loading"
  );

  useEffect(() => {
    let cancelled = false;
    authService
      .session()
      .then(({ user }) => {
        if (cancelled) return;
        saveUser(user);
        setState(user?.role === "admin" ? "ready" : "forbidden");
      })
      .catch(() => {
        if (cancelled) return;
        setState("unauthorized");
      });
    return () => {
      cancelled = true;
    };
  }, [location.pathname]);

  if (state === "loading") return <Spin fullscreen />;
  if (state === "unauthorized") {
    return <Navigate to={RouteEnum.Login} state={{ from: location }} replace />;
  }
  if (state === "forbidden" || !isAdmin()) {
    return <Navigate to={RouteEnum.Extractpdf} replace />;
  }
  return <Outlet />;
};

export const PublicOnly = () =>
  getUser() ? <Navigate to={RouteEnum.Extractpdf} replace /> : <Outlet />;
